const useManualHairTypeSelection = ({
  hairTypeStep,
  questions,
  addUserMessage,
  saveAnswer,
  upsertDerivedAnswer,
  getAnswersMap,
  findNextVisibleQuestion,
  askQuestion,
  completeQuestionFlow,
  closeManualHairTypeGrid,
  closeCamera,
}) => {
  const handleManualHairTypeSelection = (option) => {
    const selectedValue = option.value || option
    const selectedLabel = option.label || selectedValue

    addUserMessage({
      text: selectedLabel,
    })

    if (!hairTypeStep) return

    saveAnswer({
      step: hairTypeStep,
      text: selectedValue,
      extractedValue: selectedValue,
      value: selectedValue,
      isValid: true,
      attempt: 1,
    })

    upsertDerivedAnswer('correctedHairClass', selectedValue)

    upsertDerivedAnswer('predictedHairClass', selectedValue)

    upsertDerivedAnswer('hairPrediction', {
      predictedHairClass: selectedValue,
      predictedHairDescription: `Selected hair class ${selectedValue}`,
    })

    upsertDerivedAnswer(
      'isPredictedHairClassCorrect',
      'No',
    )

    closeManualHairTypeGrid()
    closeCamera()

    const currentIndex = questions.findIndex(
      (step) =>
        step.id === 'hair_prediction_corrected_value',
    )

    const answersMap = getAnswersMap()

    const nextVisible = findNextVisibleQuestion(
      currentIndex + 1,
      answersMap,
    )

    if (nextVisible !== null) {
      askQuestion(nextVisible)
      return
    }

    completeQuestionFlow()
  }

  return {
    handleManualHairTypeSelection,
  }
}

export default useManualHairTypeSelection